function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1_Artikel_Artikel-Copy",
  transform: "translate(-390.000000, -327.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Produktname_001",
  transform: "translate(20.000000, 101.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(370.000000, 226.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#CDCDCD",
  strokeWidth: 10,
  cx: 175,
  cy: 175,
  r: 170
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#CDCDCD",
  fillRule: "nonzero",
  x: 146.28483,
  y: 267.647059,
  width: 57.4303406,
  height: 13.003096,
  rx: 6.50154799
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.916254,98.4160697 C135.259202,85.6672957 141.748151,85.6672957 137.383103,98.4160697 C130.835531,117.539231 95.7164814,137.616099 71.4035078,137.616099 C47.0905343,137.616099 44.0379783,126.51922 64.3534573,120.595163 C77.8971101,116.645792 95.7513757,109.252761 117.916254,98.4160697 Z",
  id: "Path-5",
  fill: "#CDCDCD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.167337,98.4160697 C255.332216,109.252761 273.186481,116.645792 286.730134,120.595163 C307.045613,126.51922 303.993057,137.616099 279.680084,137.616099 C255.36711,137.616099 220.24806,117.539231 213.700488,98.4160697 C209.33544,85.6672957 215.82439,85.6672957 233.167337,98.4160697 Z",
  id: "Path-5-Copy",
  fill: "#CDCDCD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.8236674,170.410318 C92.4839441,177.945523 108.307238,178.643934 126.293549,172.505552 C144.279859,166.36717 144.279859,172.07723 126.293549,189.635731 C109.069313,203.404122 92.455744,202.582943 76.4528422,187.172193 C60.4499405,171.761444 61.2402155,166.174152 78.8236674,170.410318 Z",
  id: "Path-6",
  fill: "#CDCDCD",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.427107,170.410318 C292.010558,166.174152 292.800833,171.761444 276.797932,187.172193 C260.79503,202.582943 244.181461,203.404122 226.957225,189.635731 C208.970915,172.07723 208.970915,166.36717 226.957225,172.505552 C244.943536,178.643934 260.76683,177.945523 274.427107,170.410318 Z",
  id: "Path-6-Copy",
  fill: "#CDCDCD",
  fillRule: "nonzero"
})))));

var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "350px",
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.abf07b97.svg";
export { ForwardRef as ReactComponent };